<template>
<div class="select">
    <div class="which" v-if="wayType === 'phone' || wayType === 'email'">
        <div class="ph-em" :class="{selected: wayType === 'email'}" @click="selectWay('email')"><span>{{ $t($loginLangPrefix('userSign.email')) }}</span>
        </div><div class="ph-em" :class="{selected: wayType === 'phone'}" @click="selectWay('phone')"><span>{{ $t($loginLangPrefix('userSign.phone')) }}</span>
        </div>
        <div class="blue" :class="{'email': wayType === 'email', 'phone': wayType === 'phone'}"></div>
    </div>
    <div class="which mb" v-else>
        <div class="abtn ebtn" @click="selectWay('m-email')">{{ $t($loginLangPrefix('userSign.email')) }}</div>
        <div class="abtn pbtn" @click="selectWay('m-phone')">{{ $t($loginLangPrefix('userSign.phone')) }}</div>
    </div>
</div>
</template>
<script>


export default {
    name: 'selectWay',
    props: {
        src: { type: String, default: '' },
        wayType: { type: String, default: '' }
    },
    components: {
    },
    data() {
        return {
        };
    },
    methods: {
        selectWay(type) {
            // this.wayType = type;
            this.$emit('selectWay', type);
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.select {
    // position: relative;
    // width: 100%;
    // height: 30px;
    .which {
        position: relative;
        display: block;
        width: 100%;
        height: 30px;
        padding: 0 60px;
        box-sizing: border-box;
        .ph-em {
            display: inline-block;
            height: 100%;
            width: 100px;
            vertical-align: top;
            font-size:16px;
            font-family: 'RobotoRegular';
            font-weight: normal;
            color:rgba(153,153,153,1);
            text-align: center;
            border-bottom: 2px solid rgba(246,247,249,1);
            cursor: pointer;
            &.selected {
                color:rgba(23,23,23,1);
            }
            span {
                top: 0;
            }
        }
        .blue {
            position: absolute;
            width:100px;
            height:2px;
            background:rgba(157,29,255,1);
            border-radius:2px;
            bottom: -2px;
            // border-radius:18px;
            // left: 0;
            transition: all linear .2s;
            transform: translate(100px, 0);
            &.email {
                transform: translate(0, 0);
            }
        }
        &.mb {
            position: relative;
            display: block;
            padding: 0;
            width: 100%;
            height: rem(235);
            top: rem(80);
            .abtn {
                width: 100%;
                height: rem(50);
                border-radius: rem(25);
                text-align: center;
                font-size: 17px;
                font-family: 'RobotoMedium';
                font-weight: 500;
                line-height: rem(50);
                color:rgba(255,255,255,1);
                background-repeat: no-repeat;
                background-size: rem(22) rem(22);
                background-position: rem(27) center;
            }
            .pbtn {
                background-color:rgba(157,29,255,1);
                background-image: url('./images/phone.png');
                margin-top: rem(15);
            }
            .ebtn {
                background-color:rgba(0,158,255,1);
                background-image: url('./images/email.png');
            }
        }
    }
}
</style>
